import { put, call, takeEvery, select } from 'redux-saga/effects'
import { reset, change, initialize } from 'redux-form'
import { yesNoModal } from '../../modalsListeners/yesNoModal'
import dossierActionsTypes from '../../../constants/actions/dossier/dossier'
import { dossierTypes as dossierTypesConstant } from '../../../constants/dossier/common/dossierTypes'
import messageModalActions from '../../../actions/modals/messageModal'
import { updateExtraSaleSuccess } from '../../../actions/dossier/sales'
import { showLoader, hideLoader } from '../../../actions/common'
import { handleError } from '../../errors/errorManager'
import { initializeDossier } from '../commonDossierSagas'
import { v4 as uuidv1 } from 'uuid'
import { updateEconomicPlanFleet } from '../../../actions/management/management'

export function * createExtraSale ({ newExtraSale, resolve, reject, dossierType }) {
  try {
    let stateDossier, economicState, dossierForm, formName, updateFunction

    if (dossierType === dossierTypesConstant.fleetEconomicPlan) {
      stateDossier = yield select(state => state.management.economicPlanModal)
      economicState = JSON.parse(JSON.stringify(stateDossier.dossierEconomicComponent))
      dossierForm = yield select(state => state.form.economicPlanModal.values.dossierEconomicComponent)
      formName = 'economicPlanModal'
      updateFunction = updateEconomicPlanFleet
    } else {
      stateDossier = yield select(state => state.salesDossier)
      economicState = JSON.parse(JSON.stringify(stateDossier.dossierEconomicComponent))
      dossierForm = yield select(state => state.form.salesDossier.values.dossierEconomicComponent)
      formName = 'salesDossier'
      updateFunction = updateExtraSaleSuccess
    }

    let newEconomic = JSON.parse(JSON.stringify(dossierForm))
    // changes(add & delete items changes state not form)
    newEconomic.extraSales = economicState.extraSales
    newExtraSale.dossierId = stateDossier.dossierId
    newExtraSale.amount = parseFloat(newExtraSale.amount)
    newExtraSale.cost = parseFloat(newExtraSale.cost)
    newExtraSale.indexFront = uuidv1()
    newEconomic.extraSales.push(newExtraSale)

    if (dossierType === dossierTypesConstant.fleetEconomicPlan) {
      yield put(updateFunction(newEconomic))
    } else {
      yield put(updateFunction(newEconomic.extraSales))
    }
    yield put(change(formName, 'dossierEconomicComponent', newEconomic))

    yield put(messageModalActions.openSuccessMessageModal('MESSAGES.POST_TABLE_ITEM_SUCCESS'))
    yield call(resolve)
  } catch (error) {
    const customHandler = function * (customHandlerError) {
      if (customHandlerError.json && (customHandlerError.json.tag === 'DossierOutOfDate' || customHandlerError.json.tag === 'TRANS/DossierOutOfDate')) {
        yield put(hideLoader())
        const confirmedReloadWarning = yield call(yesNoModal, 'DossierOutOfDate')
        if (confirmedReloadWarning) {
          const salesDossierState = yield select(state => state.salesDossier)
          yield call(initializeDossier, dossierTypesConstant.sales, salesDossierState)
        }
      } else {
        yield put(messageModalActions.openErrorMessageModal('MESSAGES.POST_TABLE_ITEM_ERROR', customHandlerError.json ? customHandlerError.json.tag : ''))
      }
      yield call(reject, customHandlerError)
    }
    const sessionHandler = function * () {
      yield put(reset('salesDossier'))
    }
    yield call(handleError, { error, customHandler, sessionHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchCreateExtraSale () {
  yield takeEvery(dossierActionsTypes.CREATE_EXTRA_SALE, createExtraSale)
}

export function * deleteExtraSale ({ extraSale, dossierType }) {
  try {
    let stateDossier, economicState, dossierForm, formName, updateFunction

    if (dossierType === dossierTypesConstant.fleetEconomicPlan) {
      stateDossier = yield select(state => state.management.economicPlanModal)
      economicState = JSON.parse(JSON.stringify(stateDossier.dossierEconomicComponent))
      dossierForm = yield select(state => state.form.economicPlanModal.values.dossierEconomicComponent)
      formName = 'economicPlanModal'
      updateFunction = updateEconomicPlanFleet
    } else {
      stateDossier = yield select(state => state.salesDossier)
      economicState = JSON.parse(JSON.stringify(stateDossier.dossierEconomicComponent))
      dossierForm = yield select(state => state.form.salesDossier.values.dossierEconomicComponent)
      formName = 'salesDossier'
      updateFunction = updateExtraSaleSuccess
    }

    let newEconomic = JSON.parse(JSON.stringify(dossierForm))

    // changes(add & delete items changes state not form)
    newEconomic.extraSales = economicState.extraSales
    let index = extraSale.id ? newEconomic.extraSales.findIndex(d => d.id === extraSale.id)
      : newEconomic.extraSales.findIndex(d => d.indexFront === extraSale.indexFront)
    newEconomic.extraSales.splice(index, 1)
    yield put(showLoader())

    if (dossierType === dossierTypesConstant.fleetEconomicPlan) {
      yield put(updateFunction(newEconomic))
    } else {
      yield put(updateFunction(newEconomic.extraSales))
    }
    yield put(change(formName, 'dossierEconomicComponent', newEconomic))
  } catch (error) {
    const customHandler = function * (customHandlerError) {
      if (customHandlerError.json && (customHandlerError.json.tag === 'DossierOutOfDate' || customHandlerError.json.tag === 'TRANS/DossierOutOfDate')) {
        yield put(hideLoader())
        const confirmedReloadWarning = yield call(yesNoModal, 'DossierOutOfDate')
        if (confirmedReloadWarning) {
          const salesDossierState = yield select(state => state.salesDossier)
          yield call(initializeDossier, dossierTypesConstant.sales, salesDossierState)
        }
      } else {
        yield put(messageModalActions.openErrorMessageModal('', customHandlerError.json ? customHandlerError.json.tag : ''))
      }
    }
    const sessionHandler = function * () {
      yield put(reset('salesDossier'))
    }
    yield call(handleError, { error, customHandler, sessionHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchDeleteExtraSale () {
  yield takeEvery(dossierActionsTypes.DELETE_EXTRA_SALE, deleteExtraSale)
}

export function * updateExtraSale ({ extraSale, resolve, reject, dossierType }) {
  try {
    let stateDossier, economicState, dossierForm, formName, updateFunction

    if (dossierType === dossierTypesConstant.fleetEconomicPlan) {
      stateDossier = yield select(state => state.management.economicPlanModal)
      economicState = JSON.parse(JSON.stringify(stateDossier.dossierEconomicComponent))
      dossierForm = yield select(state => state.form.economicPlanModal.values.dossierEconomicComponent)
      formName = 'economicPlanModal'
      updateFunction = updateEconomicPlanFleet
    } else {
      stateDossier = yield select(state => state.salesDossier)
      economicState = JSON.parse(JSON.stringify(stateDossier.dossierEconomicComponent))
      dossierForm = yield select(state => state.form.salesDossier.values.dossierEconomicComponent)
      formName = 'salesDossier'
      updateFunction = updateExtraSaleSuccess
    }

    let newEconomic = JSON.parse(JSON.stringify(dossierForm))

    // changes(add & delete items changes state not form)
    newEconomic.extraSales = economicState.extraSales
    let index = extraSale.id ? newEconomic.extraSales.findIndex(d => d.id === extraSale.id)
      : newEconomic.extraSales.findIndex(d => d.indexFront === extraSale.indexFront)
    extraSale.amount = parseFloat(extraSale.amount)
    extraSale.cost = parseFloat(extraSale.cost)
    newEconomic.extraSales[index] = extraSale

    if (dossierType === dossierTypesConstant.fleetEconomicPlan) {
      yield put(updateFunction(newEconomic))
    } else {
      yield put(updateFunction(newEconomic.extraSales))
    }
    yield put(change(formName, 'dossierEconomicComponent', newEconomic))
    yield call(resolve)
  } catch (error) {
    const customHandler = function * (customHandlerError) {
      if (customHandlerError.json && (customHandlerError.json.tag === 'DossierOutOfDate' || customHandlerError.json.tag === 'TRANS/DossierOutOfDate')) {
        yield put(hideLoader())
        const confirmedReloadWarning = yield call(yesNoModal, 'DossierOutOfDate')
        if (confirmedReloadWarning) {
          const salesDossierState = yield select(state => state.salesDossier)
          yield call(initializeDossier, dossierTypesConstant.sales, salesDossierState)
        }
      } else {
        yield put(messageModalActions.openErrorMessageModal('', customHandlerError.json ? customHandlerError.json.tag : ''))
      }
      yield call(reject, customHandlerError)
    }
    const sessionHandler = function * () {
      yield put(reset('salesDossier'))
    }
    yield call(handleError, { error, customHandler, sessionHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchUpdateExtraSale () {
  yield takeEvery(dossierActionsTypes.UPDATE_EXTRA_SALE, updateExtraSale)
}

export function * fetchProcessingAgencyModal ({ amount, amountImc, ivaType, iemType, iemPercentage, pristine, dossierType }) {
  try {
    let formName, stateDossier
    if (dossierType === dossierTypesConstant.fleetEconomicPlan) {
      formName = 'economicPlanModal'
    } else {
      formName = 'salesDossier'
    }

    if (amount) yield put(change(formName, 'processingAgencyModal.amount', amount))
    if (ivaType) yield put(change(formName, 'processingAgencyModal.ivaType', ivaType))
    if (iemType) yield put(change(formName, 'processingAgencyModal.iemType', iemType))
    if (amountImc) yield put(change(formName, 'processingAgencyModal.amountImc', amountImc))
    if (iemPercentage) yield put(change(formName, 'processingAgencyModal.iemPercentage', iemPercentage))

    if (dossierType === dossierTypesConstant.fleetEconomicPlan) {
      stateDossier = JSON.parse(JSON.stringify(yield select(state => state.form.economicPlanModal.values)))
    } else {
      stateDossier = JSON.parse(JSON.stringify(yield select(state => state.form.salesDossier.values)))
    }

    yield put(initialize(formName, stateDossier))
  } catch (error) {
    const customHandler = function * (customHandlerError) {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.SALES_DOSSIER.ERROR_PROCESSING_AGENCY_MODAL_DATA', customHandlerError.json ? customHandlerError.json.tag : ''))
    }
    yield call(handleError, { error, customHandler })
  }
}

export function * watchFetchProcessingAgencyModal () {
  yield takeEvery(dossierActionsTypes.FETCH_PROCESSING_AGENCY_MODAL, fetchProcessingAgencyModal)
}
